/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TriageAssignmentIn } from './triageAssignmentIn';

export interface TriagePerCandidateIn {
  action: 'per_candidate';
  /**
     * @minItems 1
     * @maxItems 50
     */
  assignments: TriageAssignmentIn[];
}
